import React__default from 'react';
import { Container } from '../Container/Container.js';

const Flex = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    topSlot,
    bottomSlot,
    className = '',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement("section", {
    className: `${className} b-flex`,
    ref: ref,
    "data-testid": "flex"
  }, topSlot && /*#__PURE__*/React__default.createElement("div", {
    className: "b-flex__top-slot"
  }, topSlot), /*#__PURE__*/React__default.createElement(Container, rest, children), bottomSlot && /*#__PURE__*/React__default.createElement("div", {
    className: "b-flex__bottom-slot"
  }, bottomSlot));
});
Flex.displayName = 'Flex';

export { Flex };
